import services from "../services";
import * as types from "./mutation-type";

export const ActionSetObservacao = ({ commit }, payload) => {
    commit(types.SET_OBSERVACAO, payload)
}

export const ActionSendPayment = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        try {
            const { data } = await services.ActionSendPayment(payload)
            if(!data?.error) {
                resolve(data)
                return
            }
            reject(data)
        } catch (error) {
            // 500 do Laravel vem como {"message":"Server Error"}: troca por um
            // texto que diz o que fazer, sem detalhe tecnico. Sem response
            // (rede caiu) o pedido pode ter sido criado mesmo assim, entao o
            // cliente confere os pedidos antes de tentar de novo.
            const status = error?.response?.status
            if (!status) {
                reject({ msg: 'Não recebemos a confirmação do pagamento. Confira em Meus pedidos antes de tentar novamente.' })
                return
            }
            if (status >= 500) {
                reject({ msg: 'Não foi possível finalizar o pagamento agora. Confira seus dados e tente novamente em alguns instantes.' })
                return
            }
            reject(error?.response?.data ?? error)
        }
    })
}

export const ActionGetSafraPayAntifraudConfig = async ({_}, payload) => {
    try {
        const { data } = await services.ActionGetSafraPayAntifraudConfig(payload)
        if (!data?.error && data?.data) {
            return data.data
        }
        throw data
    } catch (error) {
        throw error?.response?.data ?? error
    }
}

export const ActionGetSimulationYapay = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionGetSimulationYapay(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionGetSimulationPagarme = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionGetSimulationPagarme(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionGetSimulationPagSeguro = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionGetSimulationPagSeguro(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}


export const ActionSendGetNetPaymentCard = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionSendGetNetPaymentCard(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionSendIpagPaymentCredit = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionSendIpagPaymentCredit(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionSendIpagPaymentBillet = ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionSendIpagPaymentBillet(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionSendPagSeguroPaymentCard = ({_}, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.ActionSendPagSeguroPaymentCard(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionSendPagSeguroPaymentBillet = ({_}, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.ActionSendPagSeguroPaymentBillet(payload)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}

export const ActionGetPublicKeyPagSeguro = ({_}) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.ActionGetPublicKeyPagSeguro()
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    })
}
